module.exports = __webpack_public_path__ + "images/icon-192.f61b23caafc413fc8eb5db72a00e1070.png";